module.exports = __webpack_public_path__ + "assets/images/icons/education.svg?v=676aedb4";